import { useSelector } from 'react-redux';
import ProviderCommonApi from '../../../API/provider/common-api';
import SimaLandApi from '../../../API/provider/simaLand-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import ProviderProductsTable from '../../../components/Providers/Blocks/ProductsTable';
import ProviderDasboardContentWhiteBlock from '../../../components/Providers/Blocks/ProviderDasboardContent';
import ProviderUpdateStatusBlock from '../../../components/Providers/Blocks/ProviderUpdateStatus';
import { PROVIDERS, TYPE_BUTTONS } from '../../../constans';

const SimaLandPage = ({ ...props }) => {
  const user = useSelector((store) => store.user);

  const loadProducts = async () => {
    await SimaLandApi.loadProducts({})
  };
  const loadCategories = async () => {
    await SimaLandApi.loadCategories({})
  };

  const providerId = PROVIDERS.SIMALAND.id;

  const access = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <Row style={{ alignItems: 'flex-start' }}>
          <WhiteBlock style={{ alignSelf: 'stretch' }}>
            <Column style={{ marginBottom: '15px' }}>
              <Row>
                <Button type={TYPE_BUTTONS.BLUE} onClick={loadProducts} style={{ marginRight: '15px' }}>
                  Обновить остатки
                </Button>
                <Button type={TYPE_BUTTONS.BLUE} onClick={loadCategories} style={{ marginRight: '15px' }}>
                  Обновить категории
                </Button>
                <Button type={TYPE_BUTTONS.RED} onClick={() => ProviderCommonApi.nullStocks({ data: { providerId } })} style={{ marginRight: '15px' }}>
                  Обнулить остатки
                </Button>
              </Row>

              <ProviderUpdateStatusBlock providerId={providerId} />
            </Column>
          </WhiteBlock>
          <ProviderDasboardContentWhiteBlock providerId={providerId} />
        </Row>
        <ProviderProductsTable providerId={providerId} isMinPackage={true} isCityStocks={true} />
      </Content>
    </>
  );
};

export default SimaLandPage;
